// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.icon-button-row {
  display: flex;
  width: 100%;
  gap: 10px;
}

.icon-button, .gray-icon-button {
  flex: 1 1;
  background-color: var(--tg-theme-button-color);
  color: var(--tg-theme-button-text-color);
  cursor: pointer;
  border: none;
  border-radius: 12px;
  margin: 5px;
  padding: 8px;
}

.icon-button:hover, .gray-icon-button:hover {
  opacity: 0.9;
}

.buttons-icon {
  width: 20px;
  height: 20px;
}

.button-row {
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.small-button, .wide-button, .gray-button, .small-gray-button {
  background-color: var(--tg-theme-button-color);
  color: var(--tg-theme-button-text-color);
  font-size: 16px;
  border: none;
  padding: 11px;
  border-radius: 12px;
  margin: 5px;
  cursor: pointer;
}

.small-button:hover, .wide-button:hover, .gray-button:hover, .small-gray-button:hover {
  opacity: 0.9;
}

.small-button {
  width: 48%;
}
.small-gray-button {
  width: 48%;
  background-color: var(--tg-theme-hint-color);
}

.wide-button {
  width: 95%;
}

.gray-button {
  width: 95%;
  /* background-color: var(--tg-theme-destructive-text-color); */
  background-color: var(--tg-theme-hint-color);
  /* color: var(--tg-theme-hint-color); */
  /* font-size: 18px; */
}`, "",{"version":3,"sources":["webpack://./src/components/menus/Buttons.css"],"names":[],"mappings":";AACA;EACE,aAAa;EACb,WAAW;EACX,SAAS;AACX;;AAEA;EACE,SAAO;EACP,8CAA8C;EAC9C,wCAAwC;EACxC,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,8CAA8C;EAC9C,wCAAwC;EACxC,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;AACA;EACE,UAAU;EACV,4CAA4C;AAC9C;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,8DAA8D;EAC9D,4CAA4C;EAC5C,uCAAuC;EACvC,qBAAqB;AACvB","sourcesContent":["\r\n.icon-button-row {\r\n  display: flex;\r\n  width: 100%;\r\n  gap: 10px;\r\n}\r\n\r\n.icon-button, .gray-icon-button {\r\n  flex: 1;\r\n  background-color: var(--tg-theme-button-color);\r\n  color: var(--tg-theme-button-text-color);\r\n  cursor: pointer;\r\n  border: none;\r\n  border-radius: 12px;\r\n  margin: 5px;\r\n  padding: 8px;\r\n}\r\n\r\n.icon-button:hover, .gray-icon-button:hover {\r\n  opacity: 0.9;\r\n}\r\n\r\n.buttons-icon {\r\n  width: 20px;\r\n  height: 20px;\r\n}\r\n\r\n.button-row {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  width: 100%;\r\n}\r\n\r\n.small-button, .wide-button, .gray-button, .small-gray-button {\r\n  background-color: var(--tg-theme-button-color);\r\n  color: var(--tg-theme-button-text-color);\r\n  font-size: 16px;\r\n  border: none;\r\n  padding: 11px;\r\n  border-radius: 12px;\r\n  margin: 5px;\r\n  cursor: pointer;\r\n}\r\n\r\n.small-button:hover, .wide-button:hover, .gray-button:hover, .small-gray-button:hover {\r\n  opacity: 0.9;\r\n}\r\n\r\n.small-button {\r\n  width: 48%;\r\n}\r\n.small-gray-button {\r\n  width: 48%;\r\n  background-color: var(--tg-theme-hint-color);\r\n}\r\n\r\n.wide-button {\r\n  width: 95%;\r\n}\r\n\r\n.gray-button {\r\n  width: 95%;\r\n  /* background-color: var(--tg-theme-destructive-text-color); */\r\n  background-color: var(--tg-theme-hint-color);\r\n  /* color: var(--tg-theme-hint-color); */\r\n  /* font-size: 18px; */\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
